<template>
    <b-sidebar
        id="question-form-sidebar"
        :visible="isQuestionFormSidebarActive"
        bg-variant="white"
        sidebar-class="sidebar-lg"
        shadow
        backdrop
        no-header
        right
        @shown="getData(questionData)"
        @hidden="resetForm(resetData)"
        @update:visible="val => $emit('update:is-question-form-sidebar-active', val)"
    >
        <template #default="{ hide }">
            <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
                <h5 class="mb-0">FAQ Form</h5>
                <feather-icon
                    class="ml-1 cursor-pointer"
                    icon="XIcon"
                    size="16"
                    @click="hide"
                />
            </div>

            <validation-observer ref="refFormObserver" v-slot="{ handleSubmit }" >
                <b-form
                    class="p-2"
                    @submit.prevent="handleSubmit(onSubmit)"
                    @reset.prevent="resetForm"
                >
                    <b-tabs content-class="mt-1" v-if="langData.length > 0">
                        <b-tab
                            v-for="(lang, key) in langData"
                            :key="'tab-' + key"
                            :title="lang.name"
                        >
                            <validation-provider
                                :name="'question_' + lang.code"
                                rules="required"
                                v-slot="validationContext"
                            >
                                <b-form-group
                                    :label="'Question (' + lang.code + ')'"
                                    :label-for="'question_' + lang.code"
                                >
                                    <b-form-input
                                        :id="'question_' + lang.code"
                                        v-model="Data.question[lang.code]"
                                        :state="getValidationState(validationContext)"
                                        :placeholder="'Question (' + lang.code + ')'"
                                        trim
                                        autofocus
                                    />
                                    <b-form-invalid-feedback>
                                        {{ validationContext.errors[0] }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </validation-provider>

                            <validation-provider
                                :name="'answer_' + lang.code"
                                rules="required"
                                v-slot="validationContext"
                            >
                                <b-form-group
                                    :label="'Answer (' + lang.code + ')'"
                                    :label-for="'answer_' + lang.code"
                                >
                                    <!-- <b-form-input
                                        :id="'answer_' + lang.code"
                                        v-model="Data.title[lang.code]"
                                        :state="getValidationState(validationContext)"
                                        :placeholder="'Answer (' + lang.code + ')'"
                                        trim
                                        autofocus
                                    /> -->
                                    <quill-editor
                                        :id="'answer_' + lang.code"
                                        v-model="Data.answer[lang.code]"
                                        :options="snowOption"
                                    />
                                    <b-form-invalid-feedback>
                                        {{ validationContext.errors[0] }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </validation-provider>
                        </b-tab>
                    </b-tabs>

                    <b-form-group label="Is Active" label-for="isactive" class="mt-1">
                        <b-form-checkbox
                            id="isactive"
                            v-model="Data.is_active"
                            switch
                            class="custom-control-success"
                        >
                            Active
                        </b-form-checkbox>
                    </b-form-group>

                    <div class="d-flex mt-2">
                        <b-button
                            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                            variant="primary"
                            class="mr-2"
                            type="submit"
                        >
                            Submit
                        </b-button>
                        <b-button
                            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                            type="button"
                            variant="outline-secondary"
                            @click="hide"
                        >
                            Cancel
                        </b-button>
                    </div>
                </b-form>
            </validation-observer>
        </template>
    </b-sidebar>
</template>

<script>
import {
    BSidebar, BForm, BFormGroup, BFormInput, BFormCheckbox, BFormInvalidFeedback, BButton,
    BTabs, BTab
} from 'bootstrap-vue'
import { ref, watch } from '@vue/composition-api'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { quillEditor } from 'vue-quill-editor'
import formValidation from '@core/comp-functions/forms/form-validation'
import router from '@/router'
import Ripple from 'vue-ripple-directive'
import store from '@/store'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { useToast } from 'vue-toastification/composition'

export default {
    components: {
        BSidebar, BForm, BFormGroup, BFormInput, BFormCheckbox, BFormInvalidFeedback, BButton,
        BTabs, BTab, ValidationProvider, ValidationObserver, quillEditor,
    },
    directives: {
        Ripple,
    },
    props: {
        isQuestionFormSidebarActive: {
            type: Boolean,
            required: true,
        },
        questionData: {
            type: Object,
            default: () => ({}),
        },
        langData: {
            type: Array,
            default: () => [],
        },
    },
    model: {
        prop: 'isQuestionFormSidebarActive',
        event: 'update:is-question-form-sidebar-active',
    },
    data() {
        return {
            snowOption: {
                theme: 'snow',
            },
        }
    },
    setup(props, { emit }) {
        const toast = useToast()
        const userStorage = JSON.parse(localStorage.getItem('userData'))
        const placeId = ref(router.currentRoute.params.id);
        const blankData = {
            place_id: placeId.value,
            created_by: userStorage?.id || null,
            is_active: true,
            question: {},
            answer: {},
        }
        const Data = ref({ ...blankData })

        const getData = (data) => {
            if (data?.id) {
                data.is_active = data.is_active? true: false
                Data.value = data
            } else {
                Data.value = blankData
            }
        }

        const resetData = () => {
            Data.value = JSON.parse(JSON.stringify(blankData))
        }

        const onSubmit = async () => {
            let response

            if(!Data.value.id) {
                response = await store.dispatch('app-place/addFAQ', Data.value)
            } else {
                Data.value.updated_by = userStorage?.id || null
                response = await store.dispatch('app-place/updateFAQ', Data.value)
            }

            if (response.data.success) {
                toast({
                    component: ToastificationContent,
                    position: 'top-right',
                    props: {
                        title: 'Success',
                        icon: 'BellIcon',
                        variant: 'success',
                        text: response.data.message,
                    },
                })

                emit('update:is-question-form-sidebar-active', false)
                emit('refetch-data')
            } else {
                toast({
                    component: ToastificationContent,
                    position: 'top-right',
                    props: {
                        title: 'Error',
                        icon: 'BellIcon',
                        variant: 'danger',
                        text: response.data.message,
                    },
                })
            }
        }

        const {
            refFormObserver,
            getValidationState,
            resetForm,
        } = formValidation(resetData)

        return {
            refFormObserver,
            getValidationState,
            resetForm,
            getData,
            Data,
            onSubmit,
            resetData,
        }
    },
}
</script>